import type { ReactNode, SVGProps } from 'react';

const PATHS = {
  home: [
    'M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8',
    'M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
  ],
  calendar: ['M8 2v4', 'M16 2v4', 'M3 10h18'],
  calendarPlus: [
    'M8 2v4',
    'M16 2v4',
    'M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8',
    'M3 10h18',
    'M16 19h6',
    'M19 16v6',
  ],
  calendarX: ['M8 2v4', 'M16 2v4', 'M3 10h18', 'm14 14-4 4', 'm10 14 4 4'],
  calendarMove: [
    'M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5',
    'M16 2v4',
    'M8 2v4',
    'M3 10h5',
    'M17.5 17.5 16 16.3V14',
  ],
  message: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'],
  invoice: [
    'M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z',
    'M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8',
    'M12 17.5v-11',
  ],
  more: [],
  chevronDown: ['m6 9 6 6 6-6'],
  chevronLeft: ['m15 18-6-6 6-6'],
  chevronRight: ['m9 18 6-6-6-6'],
  user: ['M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2'],
  pin: [
    'M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0',
  ],
  clock: ['M12 6v6l4 2'],
  wallet: [
    'M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1',
    'M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4',
  ],
  info: ['M12 16v-4', 'M12 8h.01'],
  clipboard: [
    'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2',
    'M12 11h4',
    'M12 16h4',
    'M8 11h.01',
    'M8 16h.01',
  ],
  send: ['m21.854 2.147-10.94 10.939'],
  folder: [
    'm6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2',
  ],
  ticket: [
    'M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z',
    'M13 5v2',
    'M13 17v2',
    'M13 11v2',
  ],
  check: ['M20 6 9 17l-5-5'],
  x: ['M18 6 6 18', 'm6 6 12 12'],
  eye: [
    'M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0',
  ],
  mail: ['m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7'],
  logout: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'm16 17 5-5-5-5', 'M21 12H9'],
  phone: [
    'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z',
  ],
  searchOff: ['M2 21a8 8 0 0 1 13.292-6', 'm17 17 5 5', 'm22 17-5 5'],
  paperclip: [
    'm21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48',
  ],
  pencil: [
    'M12 20h9',
    'M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z',
  ],
  download: ['M12 17V3', 'm6 11 6 6 6-6', 'M19 21H5'],
  video: [
    'm16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5',
    'M2 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z',
  ],
  first: [
    'M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z',
  ],
  card: ['M2 10h20'],
  smartphone: ['M12 18h.01'],
} as const;

const CIRCLES = {
  user: { cx: 12, cy: 7, r: 4 },
  pin: { cx: 12, cy: 10, r: 3 },
  clock: { cx: 12, cy: 12, r: 10 },
  info: { cx: 12, cy: 12, r: 10 },
  calendarMove: { cx: 16, cy: 16, r: 6 },
  eye: { cx: 12, cy: 12, r: 3 },
  searchOff: { cx: 10, cy: 8, r: 5 },
} as const;

const RECTS = {
  calendar: { width: 18, height: 18, x: 3, y: 4, rx: 2 },
  calendarX: { width: 18, height: 18, x: 3, y: 4, rx: 2 },
  clipboard: { width: 8, height: 4, x: 8, y: 2, rx: 1 },
  mail: { width: 20, height: 16, x: 2, y: 4, rx: 2 },
  card: { width: 20, height: 14, x: 2, y: 5, rx: 2 },
  smartphone: { width: 14, height: 20, x: 5, y: 2, rx: 2 },
} as const;

const MORE_RECTS = [
  { width: 7, height: 7, x: 3, y: 3, rx: 1 },
  { width: 7, height: 7, x: 14, y: 3, rx: 1 },
  { width: 7, height: 7, x: 14, y: 14, rx: 1 },
  { width: 7, height: 7, x: 3, y: 14, rx: 1 },
] as const;

export type PortalIconName = keyof typeof PATHS;

export function PortalIcon({
  name,
  size,
  className,
  ...rest
}: {
  name: PortalIconName;
  size?: 'xs' | 'sm' | 'lg';
} & SVGProps<SVGSVGElement>) {
  const extra: ReactNode[] = [];
  if (name === 'more') {
    for (const rect of MORE_RECTS) {
      extra.push(<rect key={`${rect.x}-${rect.y}`} {...rect} />);
    }
  }
  const circle = CIRCLES[name as keyof typeof CIRCLES];
  const rect = RECTS[name as keyof typeof RECTS];
  return (
    <svg
      className={['i', size, className].filter(Boolean).join(' ')}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {rect ? <rect {...rect} /> : null}
      {circle ? <circle {...circle} /> : null}
      {PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
      {name === 'send' ? (
        <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
      ) : null}
      {extra}
    </svg>
  );
}

export function ClinicFallbackMark() {
  return (
    <svg className="cl-logo" viewBox="0 0 40 40" aria-hidden="true">
      <rect width="40" height="40" rx="12" fill="var(--teal)" />
      <path d="M20 8 27 26 20 22 13 26Z" fill="var(--bg)" />
      <circle cx="20" cy="31" r="2" fill="var(--bg)" />
    </svg>
  );
}
